import { Grid } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import TableGeneric from "../../../compartidos/abms/TableGeneric";
import AddButtonAbm from '../../../compartidos/abms/AddButtonAbm';
import { FormProveedorContacto } from "./FormProveedorContacto";
import EditButtonAbm from "../../../compartidos/abms/EditButtonAbm";
import DeleteButtonAbm from "../../../compartidos/abms/DeleteButtonAbm";
import { crearNuevoDatosContacto, eliminarDatosContacto, guardarDatosContacto, traerDatosContactoProveedor } from "../../../../actions/compras/ProveedoresAction";
import {useEffect, useSelector} from "react";
import { MENU_PROVEEDORES } from "../../../../utils/constants";
import { useDispatch } from "react-redux";

export const DatosContactoProveedor = (props) => {
  
  const dispatch = useDispatch();

  const {Menu} = props;
  const { proveedorInfo, datosContacto } = useSelector((state) => state.proveedores);

  const handleSave = (formValues, handleClose) => {
    dispatch(crearNuevoDatosContacto(formValues, handleClose));
  }

  const handleEdit = (formValues, handleClose) => {
    dispatch(guardarDatosContacto(proveedorInfo.idProveedor, formValues, handleClose))
}

const handleDelete = (proveedorInfo, handleClose) => {
    dispatch(eliminarDatosContacto(proveedorInfo, handleClose))
}

useEffect(() => {
  if(proveedorInfo.idProveedor){
    dispatch(traerDatosContactoProveedor(proveedorInfo.idProveedor))
  }
}, [dispatch,proveedorInfo.idProveedor])

console.log(datosContacto)
  return (
    <>
      <Grid container spacing={1} component={Paper} style={{ padding: "40px" }}>
        <Grid
          item
          xs={12}
          style={{ textAlign: "right", marginTop: "2rem" }}
        >
          {Menu === MENU_PROVEEDORES.INGRESO &&
            <AddButtonAbm
            title="+ Agregar Contacto"
            form={FormProveedorContacto}
            handleSave={handleSave}
            permiso={null}
          />
          }
          
        </Grid>
        <TableGeneric
          data={datosContacto}
          align={"center"}
          columns={[
            {
              label: "Tipo Contacto",
              id: "idTipoContacto",
              sort: true,
            },
            {
              label: "Nombre y Apellido",
              id: "nombreApellido",
              sort: true,
            },
            {
              label: "Cargo",
              id: "cargo",
              sort: true,
            },
            {
              label: "Mail",
              id: "mail",
              sort: true,
            },
            {
              label: "Telefono",
              id: "telefono",
              sort: true,
            },
            {
              label: "Celular",
              id: "celular",
              sort: true,
            },
            {
              label: "Direccion",
              id: "direccion",
              sort: true,
            },
            {
              label: "Observaciones",
              id: "observaciones",
              sort: true,
            },
            {
              
              label: "",
              customBody: (item) => {
                return Menu === MENU_PROVEEDORES.INGRESO &&
                <>
                    <EditButtonAbm 
                        form={FormProveedorContacto}
                        item={item}
                        handleSave={handleEdit}
                    />

                    <DeleteButtonAbm 
                        handleDelete={() => handleDelete(item.idProveedorContacto)}
                        permiso={null}
                   />
                </>
              }
            },
            
          ]}
        />
      </Grid>
    </>
  );
};
